"use strict";

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _semanticUiReact = require("semantic-ui-react");

var _default = function _default(_ref) {
  var flag = _ref.flag,
      title = _ref.title,
      monthly = _ref.monthly,
      listOfQualities = _ref.listOfQualities,
      onPlanSelected = _ref.onPlanSelected,
      index = _ref.index;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: flag ? 'green-outline' : ''
  }, flag && /*#__PURE__*/_react["default"].createElement("div", {
    className: "payment-card-emphasis centered-content header-text"
  }, flag), /*#__PURE__*/_react["default"].createElement("div", {
    className: "payment-card"
  }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Header, {
    className: "payment-card-title centered-content header-text ".concat(flag ? 'squared-top-radius' : '')
  }, title), /*#__PURE__*/_react["default"].createElement("h4", {
    className: "payment-card-description bolded"
  }, monthly.description), /*#__PURE__*/_react["default"].createElement("div", {
    className: "payment-card-items"
  }, listOfQualities.map(function (quality, qIndex) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "payment-card-item body-text",
      key: quality
    }, (qIndex !== 0 || index === 0) && /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Icon, {
      size: "large",
      name: "check",
      className: "payment-card-item-icon"
    }), /*#__PURE__*/_react["default"].createElement("p", null, quality));
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "payment-card-cta"
  }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Button, {
    className: "select",
    onClick: function onClick() {
      return onPlanSelected(index);
    }
  }, "Select this plan"))));
};

exports["default"] = _default;